import React from 'react'
import styled from 'styled-components'
import truncate from 'lodash/truncate'

import { ParagraphMicro, ParagraphXxs } from 'components/display/Typography'
import LazyImage from 'components/display/LazyImage'
import {
  AutocompleteDropdownResult,
  DropDownWrapper,
  DropdownTitle,
} from '../styles'

const SelectListImg = styled.div`
  height: 0;
  width: 35%;
  padding-bottom: 35%;
  border-radius: 6px;
  position: relative;
  overflow: hidden;

  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }

  + div {
    width: 65%;
    padding-left: 12px;
  }
`

interface CardItemProps {
  heading: string
  title: string
  subtitle: string
  url: string
  image: string
  onClick: (arg: string) => any
}

const EscapeItem = ({
  heading,
  title,
  subtitle,
  url,
  image,
  onClick,
}: CardItemProps) => (
  <AutocompleteDropdownResult
    className="qa-result"
    onClick={() => onClick(url)}
  >
    <SelectListImg>
      <LazyImage data-src={image} alt={title} />
    </SelectListImg>

    <DropDownWrapper>
      <ParagraphMicro uppercase noMargin>
        {heading}
      </ParagraphMicro>
      <DropdownTitle>{truncate(title, { length: 40 })}</DropdownTitle>
      <ParagraphXxs noMargin>{subtitle}</ParagraphXxs>
    </DropDownWrapper>
  </AutocompleteDropdownResult>
)

export default EscapeItem
